// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 2/14/2024 12:28:28 PM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

export enum CompanyTypeEnum {
  notDefined = 0,
  wagepoint = 1,
  customer = 2,
  client = 4,
  partnerIndependent = 8,
  partnerRegional = 16,
  partnerNational = 32,
}

export enum MigrationTypeEnum {
  upgrade = 1,
  connect = 2,
}

export enum CompanyStatusTypeEnum {
  notDefined = 0,
  waitingData = 1,
  pendingVerification = 2,
  active = 3,
  inActive = 4,
  closeInitiated = 5,
  closePending = 6,
  closed = 7,
  expired = 8,
  banned = 9,
}

export enum PropertyTypeEnum {
  notDefined = 0,
  craNumber = 1,
  fein = 2,
  rqNumber = 3,
  remitSchedule = 4,
  serviceLevel = 5,
  revenuQuebecNumber = 6,
  renvueQuebecHsfRate = 7,
  remittanceSchedule = 8,
  eligibleForSusidary = 9,
  autoRunDefault = 10,
  noChurn = 11,
  autoSubmitT4 = 12,
  isTestCompany = 13,
  hasUbiquityAccount = 14,
  masterTaxId = 15,
  twitter = 16,
  facebook = 17,
  linkedIn = 18,
  employerHealthTaxNoticeSent = 19,
  employerHealthTaxSecondNoticeSent = 20,
  natpayId = 21,
  iRSNameControl = 22,
  eFTPSPin = 23,
  iRSNameControlDate = 24,
  fedTaxExperiecneRate = 25,
  jobDescriptionCode = 26,
  roeAddendumSignatureDate = 27,
}

export enum ContactTypeEnum {
  notDefined = 0,
  bank = 1,
  benefits = 2,
  general = 3,
  primaryContact = 4,
  roe = 5,
  taxes = 6,
}

export enum GlCodeTypeEnum {
  notDefined = 0,
  processingCredit = 1,
  processingFee = 2,
  field = 3,
}

export enum SettingsTypeEnum {
  notDefined = 0,
  jobTitles = 1,
  departments = 2,
  multiLocations = 3,
  hourlyPay = 4,
  salryPay = 5,
  directDeposit = 6,
  drectWithdrawal = 7,
  payCra = 8,
  wcb = 9,
  customReports = 10,
  canRunMultiCompany = 11,
  creditApSubmitted = 12,
  paymentInfoSubmitted = 13,
  enforceNbovtRule = 14,
  invoiceParent = 15,
  noCommission = 16,
}

export enum TutorialTypeEnum {
  notDefined = 0,
  type1 = 1,
  type2 = 2,
  type3 = 3,
  type4 = 4,
  type5 = 5,
}

export enum TimeSheetFormatTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  decimal = 2,
  time = 3,
}

export enum PrintStockTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  sageLaser = 2,
  quickbooksVoucher = 3,
  quickbooksStandard = 4,
}

export enum LocationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  headquarters = 2,
}

export enum CountryTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  us = 2,
  canada = 3,
}

export enum OwnerTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  wagepoint = 2,
  company = 3,
  payGroup = 4,
}

export enum LocationStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  enabled = 2,
  disabled = 3,
  deleted = 4,
}

export enum TaxIdTypeEnum {
  notDefined = 0,
  federal = 1,
  state = 2,
}

export enum CompanyToggleTypeEnum {
  notDefined = 0,
  jobTitles = 1,
  departments = 2,
  multipleLocations = 3,
  payByDirectDeposit = 4,
  taxRemitted = 5,
  autoSubmitTaxForms = 6,
  workmansComp = 7,
  delayPayStubs = 8,
  windowedEnvelopes = 9,
  showTaxes = 10,
  showBenefits = 11,
  showVacation = 12,
  twoStepApproval = 13,
  notifyProcessing = 14,
  notifiyCalendar = 15,
  notifyPayrollApproved = 16,
  notifyReportsAvailable = 17,
  notifyEmployeeBirthday = 18,
  notifyEmployeeAnniversary = 19,
  notifyLatePayroll = 20,
  adjustVacationHoursInRegularPay = 21,
}

export enum SecurityRoleTypeEnum {
  notDefined = 0,
  accountOwner = 1,
  accountSignatory = 2,
  manager = 3,
  administrator = 4,
  reportsManager = 5,
  administratorSubmitter = 6,
  administratorApprover = 7,
  accountAdministrator = 8,
  employee = 9,
  contractor = 10,
  riskAgent = 15,
}

export enum DocumentTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  driverLicenseFront = 2,
  driverLicenseBack = 3,
  bankCheck = 4,
  governmentId = 5,
  ariticlesOfIncorporation = 6,
  voidCheck = 7,
  pad = 8,
  taxForm = 9,
  companyLogo = 10,
  personAvatar = 11,
  natPay = 12,
  payPeriodDocument = 13,
  roeSat = 14,
  roe = 15,
  bankFile = 16,
  accountValidation = 17,
  accountOwnership = 18,
  governmentIdBack = 19,
  additionalRiskdocument = 20,
  plaidAssetReport = 21,
  yearEnd = 22,
  yearEndXml = 23,
  payrollAttachment = 24,
}

export enum FormStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  created = 2,
  uploaded = 3,
  accepted = 4,
  cancelled = 5,
  pending = 6,
  complete = 7,
  rejected = 8,
  pendingVerification = 9,
  deleted = 10,
  skipFormSubmission = 11,
}

export enum FormTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  taxAgreement = 2,
  yearEnd = 3,
  roe = 4,
  bankAgreement = 5,
}

export enum SignatureTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  physical = 2,
  notary = 3,
  esign = 4,
}

export enum ConnectionStatusTypeEnum {
  notDefined = 0,
  connected = 1,
  disconnected = 2,
}

export enum InvitationStatusTypeEnum {
  notDefined = 0,
  pending = 1,
  accepted = 2,
  revoked = 3,
  declined = 4,
}

export enum RemittanceFrequencyTypeEnum {
  notDefined = 0,
  notSpecidfied = 1,
  regular = 2,
  threshold1 = 3,
  threshold2 = 4,
}

export enum ApprovalTypeEnum {
  notDefined = 0,
  payroll = 1,
}

export enum ReportTypeEnum {
  notDefined = 0,
  journalEntry = 1,
  bill = 2,
  wagepointInvoice = 3,
  accountsPayableInvoice = 4,
  subscriptionFeeInvoice = 5,
}

export enum ExplicitFormTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  t4 = 2,
  t4A = 3,
  rL1 = 4,
  w2 = 5,
  w3 = 6,
  ten99 = 7,
  roeEn = 8,
  bankAgreementPreAuth = 9,
  bankAgreementNatPay = 10,
  roeRegistrationAddendumEn = 11,
  roeRegistrationAddendumFr = 12,
  t4Summary = 13,
  t4ASummary = 14,
  rL1Summary = 15,
  roeFr = 16,
  padConfirmation = 17,
  accountValidationEn = 18,
  accountValidationFr = 19,
  t4Xml = 20,
  t619Xml = 21,
  t4SummaryXml = 22,
  t4aXml = 23,
  t4aSummaryXml = 24,
}

export enum CompanyCloseOutReasonTypeEnum {
  notDefined = 0,
  movingToNewPayrollProvider = 1,
  notRunningPayrollAtTheMoment = 2,
  ceasingOperations = 3,
}

export enum YearEndViolationTypeEnum {
  notSpecified = 0,
  none = 1,
  mIssingEmail = 2,
  notLoggedInYet = 3,
  missingHomeAddress = 4,
  inalidInsuranceNumber = 5,
  cppProblems = 6,
  eiProblems = 7,
}

export enum YearEndCheckStatusTypeEnum {
  notSpecified = 0,
  underPayment = 1,
  overpayment = 2,
  otherViolation = 3,
  allSatisfied = 4,
}

export enum YearEndPackageTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  package = 2,
  packageAmendment = 3,
}

export enum YearEndPackageStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  draft = 2,
  filingInProgress = 3,
  finalized = 4,
  submissionInProgress = 5,
  filed = 6,
  generated = 7,
  deleted = 8,
  submitted = 9,
  failedToProcess = 10,
  fileGenerationInProgress = 11,
}

export enum YearEndSubmissionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  electronic = 2,
  manual = 3,
}

export enum YearEndViewTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  single = 2,
  grid = 3,
}

export enum CompanyTaxPropertyTypeEnum {
  notDefined = 0,
  taxNumber = 1,
  taxRate = 2,
  remittanceFrequency = 3,
  exemptionThreshold = 4,
  thresholdPassed = 5,
  remit = 6,
  ytdRemittance = 7,
  isReducedRate = 8,
  ytdAmount = 9,
  reductionTaxNumber = 10,
}

export enum CompanyTaxAccountUpdateReasonTypeEnum {
  notDefined = 0,
  companyAcquired = 1,
  companyMerged = 2,
}

export enum TaxFormWorkflowStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  pdfGenerated = 2,
  xmlGenerated = 3,
  completed = 4,
}

export enum PayrollAccountYtdBalanceActionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  carryOverBalances = 2,
  startBalancesFresh = 3,
}

export enum CompanyLogContactTypeEnum {
  notDefined = 0,
  demo = 1,
  email = 2,
  phone = 3,
  voiceMail = 4,
  textMessage = 5,
  socialChannel = 6,
}

export enum CompanyLogSourceTypeEnum {
  notDefined = 0,
  ticket = 1,
}

export enum CompanyLogStatusTypeEnum {
  notDefined = 0,
  completed = 1,
}

export enum CompanyOnboardingStepStatusTypeEnum {
  notDefined = 0,
  pending = 1,
  partiallyCompleted = 2,
  completed = 3,
}

export enum CompanyOnboardingStepEnum {
  notDefined = 0,
  companyDetail = 1,
  payGroup = 2,
  people = 3,
  sourceDeductions = 4,
  bankingInformation = 5,
  accountVerification = 6,
  employerTaxes = 7,
  roe = 8,
  authorizedSignatory = 9,
}

export enum ValidationScopeTypeEnum {
  notDefined = 0,
  partial = 1,
  complete = 2,
  skipValidation = 3,
}

export enum NoteTypeEnum {
  notDefined = 0,
  plaid = 1,
  trulioo = 2,
  general = 3,
}

export enum RiskAssessmentLevelTypeEnum {
  notDefined = 0,
  low = 1,
  medium = 2,
  high = 3,
}

export enum PermantRiskTypeEnum {
  notDefined = 0,
  yes = 1,
  no = 2,
}

export enum WatchlistReasonTypeEnum {
  notDefined = 0,
  nSF = 1,
  bankAccountClosed = 2,
  lowBalance = 3,
  highRisk = 4,
  doubleCheck = 5,
}

export enum RiskReviewStatusTypeEnum {
  notDefined = 0,
  inProgress = 1,
  completed = 2,
}

export enum AccountVerificationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  instant = 2,
  manual = 3,
}

export enum FormWorkflowStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  waitingToBeProcessed = 2,
  processed = 3,
  failedToProcess = 4,
}

export enum PdfWorkflowStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  waitingToBeGenerated = 2,
  generated = 3,
  failedToGenerate = 4,
}

export enum InactivateReasonTypeEnum {
  notDefined = 0,
  fraudRisk = 1,
  creditRisk = 2,
  reputationalRisk = 3,
  other = 4,
}

export enum CloseOutReasonTypeEnum {
  notDefined = 0,
  leaving = 1,
  stop = 2,
}

export enum CompanySettingTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  timeSheetFormatType = 2,
  printStockType = 3,
  invoiceParent = 4,
  decendentIdList = 5,
  baseFieldExclusions = 6,
  logoId = 7,
  useLogoAsFavicon = 8,
  payrollVarianceNotifyPercentage = 9,
  nsfWireTransferFee = 10,
  processingDays = 11,
  payrollProcessingHour = 12,
  remitProcessingDays = 13,
  nsfFees = 14,
  payPeriodTemplateId = 15,
  statutoryHolidaysCalculationType = 16,
  numberOfProjectedClients = 17,
  previousPayrollProvider = 18,
}

export enum CompanyInvitationTypeEnum {
  notDefined = 0,
  partnerToClient = 1,
  clientToPartner = 2,
}

export enum FormOriginationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  original = 2,
  amended = 3,
  deleted = 4,
}

export enum YearEndFileStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  draft = 2,
  inProgress = 3,
  generated = 4,
  failed = 5,
  deleted = 6,
}

export enum BlacklistDataTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  ip = 2,
  bankAccountNumber = 3,
  governmentId = 4,
}

export enum StatutoryHolidaysCalculationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  federal = 2,
  daily = 3,
  noAutomaticCalculation = 4,
}

export enum BannerTypeEnum {
  notDefined = 0,
  nsfLock = 1,
  trialExpiring = 2,
}

export enum BannerStateTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  up = 2,
  down = 3,
}

export enum XmlWorkflowStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  waitingToBeGenerated = 2,
  generated = 3,
  failedToGenerate = 4,
}

export enum DentalBenefitTypeEnum {
  notDefined = 0,
  noDentalBenefit = 1,
  payee = 2,
  payeeSpouseChildren = 3,
  payeeSpouse = 4,
  payeeChildren = 5,
}

export enum MarketingInstitutionTypeEnum {
  notDefined = 0,
  creditUnion = 1,
  association = 2,
}

export enum MigrationStepStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  completed = 2,
  failed = 3,
  skipped = 4,
}

export enum MigrationStepTypeEnum {
  notDefined = 0,
  signUpCompany = 1,
  choosePlan = 2,
  migrateCompanyDetails = 3,
  migrateAdmins = 4,
  migrateLocations = 5,
  migratePayGroups = 6,
  migrateSourceDeductions = 7,
  migrateBankAccount = 8,
  migrateAuthorizedSignatory = 9,
  submitForVerification = 10,
  riskVerifyBankAccount = 11,
  riskVerifyCompany = 12,
  migrateJob = 13,
  migrateDepartment = 14,
  migrateWcbRate = 15,
  migrateEmployerTaxes = 16,
  migratePeople = 17,
  migrateRoeSatAndContact = 18,
  migratePreviousRoeData = 19,
  migrateCompanySetttings = 20,
  sendLoginEmail = 21,
  confirmPayGroup = 22,
  signPad = 23,
}

export enum NotificationTriggerTypeEnum {
  notDefined = 0,
  approve = 1,
  reject = 2,
}

export enum CalendarEventTypeEnum {
  notDefined = 0,
  payPeriodProcessor = 1,
  calendarWatchDog = 2,
  calendarCop = 3,
  payCalPrototype = 4,
  holiday = 5,
  workflowType = 6,
  birthdayWorkAnniversaryReminder = 7,
  secureDocumentDeleter = 8,
  workflowTest = 9,
  subscriptionInvoiceProcessor = 10,
  stateHoliday = 11,
}

export enum CalendarEventStateTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  active = 2,
  completed = 3,
  deleted = 4,
}

export enum CalendarOwnerTypeEnum {
  notDefined = 0,
  country = 1,
  payGroup = 2,
  company = 3,
  workflowTest = 4,
  state = 5,
}

export enum UserTaskStateTypeEnum {
  notDefined = 0,
  taskIsWaiting = 1,
  taskInProgress = 2,
  taskCompleted = 3,
}

export enum CalendarStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  deleted = 2,
  paused = 3,
}

export enum WorkflowTemplateTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  protoType = 2,
  calendarEventPayPeriod = 3,
  calendarEventCop = 4,
  birthday = 5,
  documentDeleter = 6,
  subscriptionInvoice = 7,
}

export enum AdobeEventTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  agreementCreated = 2,
  agreementEmailViewed = 3,
  agreementActionCompleted = 4,
  agreementRejected = 5,
  agreementExpired = 6,
  agreementSigned = 7,
}

export enum IntegrationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  rcb = 2,
  google = 3,
  xero = 4,
  hubSpot = 5,
  zenDesk = 6,
  yodlee = 7,
  echo = 8,
  qbo = 9,
  trulioo = 10,
  plaid = 11,
  netSuite = 12,
  telPay = 13,
  time = 14,
  ediEht = 15,
  ediRq = 16,
  rbc = 17,
  paymentsCanada = 18,
  geoPlugin = 19,
}

export enum TicketFieldTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  natureOfInquiry = 2,
  otherNatureOfInquiry = 3,
}

export enum DisplayFieldOptionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  priorToFirstPayroll = 2,
  afterFirstPayroll = 3,
}

export enum VerificationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  businessVerification = 2,
  identityVerification = 3,
}

export enum PlaidEnvironmentTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  sandbox = 2,
  development = 3,
  production = 4,
}

export enum IntegrationSyncTypeEnum {
  notDefined = 0,
  company = 1,
  employee = 2,
  journal = 3,
  admin = 4,
  ticket = 5,
}

export enum PaymentsCanadaApiGroupTypeEnum {
  notDefined = 0,
  fifBranch = 1,
  fifExtracts = 2,
}

export enum ZendeskTicketTriggerTypeEnum {
  notDefined = 0,
  achThresholdLimit = 1,
  higherValueFirstPayroll = 2,
  higherPayrollVarience = 3,
  watchListCompanyPayrollRun = 4,
  riskyEmpBankAcc = 5,
  multipleFirstPayrollRun = 6,
  higherEmpCompRate = 7,
  higherEmpSalary = 8,
}

export enum PersonTypeEnum {
  notDefined = 0,
  employee = 1,
  contractor = 2,
  other = 3,
}

export enum FieldLedgerTypeEnum {
  notDefined = 0,
  openingBalance = 1,
  granular = 2,
  payPeriod = 3,
  year = 4,
}

export enum PayrollEmployeeStateTypeEnum {
  notDefined = 0,
  inActive = 1,
  pendingPayrollReady = 2,
  payrollReady = 3,
}

export enum KnownTaxSettingTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  usFederalExemptions = 2,
  usStateExemptions = 3,
  usBlindnessExemption = 4,
  caFederalTd1 = 5,
  caEmploymentProvince = 6,
  caEmploymentProvinceCode = 7,
  caCppExempt = 8,
  caEiExempt = 9,
  f1Amount = 10,
  hdAmount = 11,
  k3Amount = 12,
  stateDisabilityInsuranceType = 13,
  caEmploymentInsuranceReduction = 14,
  taxIncreaeDecrease = 15,
}

export enum AddressTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  home = 2,
  work = 3,
}

export enum EmailTypeEnum {
  notDefined = 0,
  primary = 1,
  secondary = 2,
}

export enum PhoneTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  homePhone = 2,
  workPhone = 3,
  mobilePhone = 4,
  fax = 5,
}

export enum StateTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  quebec = 2,
  ontario = 3,
  alberta = 4,
  manitoba = 5,
  britishColumbia = 6,
  saskatchewan = 7,
  novaSoctia = 8,
  newBrunswick = 9,
  princeEdwardIsland = 10,
  newfoundLand = 11,
  northwestTerritories = 12,
  nunavut = 13,
  yukonTerritories = 14,
}

export enum MaritalStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  single = 2,
  married = 3,
}

export enum OverrideValueTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  amount = 2,
  percent = 3,
}

export enum WcbValidationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  twoToFiveDigit = 2,
  sevenNumeric = 3,
  sevenDigit = 4,
  sevenToNineNumeric = 5,
  fifteenDigit = 6,
  sixteenDigit = 7,
}

export enum WcbRateStatusTypeEnum {
  notDefined = 0,
  active = 1,
  inActive = 2,
  deleted = 3,
  disabled = 4,
  disablePending = 5,
}

export enum StateDisabilityInsuranceEnum {
  notDefined = 0,
  subject = 1,
  exempt = 2,
}

export enum JobPayTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  hourly = 2,
  salary = 3,
  commission = 4,
}

export enum HoursTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  fixed = 2,
  vairable = 3,
}

export enum EmployeeOnboardingTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  guided = 2,
  grid = 3,
  import = 4,
}

export enum EmployeeOnboardingEmployementTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  employees = 2,
  contractors = 3,
}

export enum EmployeeStateTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  active = 2,
  terminated = 3,
  onLeave = 4,
  terminatedPending = 5,
  onLeavePending = 6,
  disabled = 7,
  pending = 8,
  incompleteProfile = 9,
  deleted = 10,
}

export enum VacationCalculationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  accrue = 2,
  payOut = 3,
  notApplicable = 4,
}

export enum UiElementTypeEnum {
  notDefined = 0,
  radioButton = 1,
  checkbox = 2,
  dropdownList = 3,
  typeAhead = 4,
  textbox = 5,
  multilineTextBox = 6,
  label = 7,
  dropDownListCheckbox = 8,
  calendar = 9,
}

export enum QuestionValueDataTypeEnum {
  string = 0,
  integer = 1,
  decimal = 2,
  boolean = 3,
}

export enum EmploymentTypeEnum {
  notDefined = 0,
  fullTime = 1,
  partTime = 2,
  commission = 3,
}

export enum FilingStatusTypeEnum {
  notDefined = 0,
  singleOrMarriedFilingSeparately = 1,
  headOfHousehold = 2,
  marriedFilingJointly = 3,
}

export enum TaxGroupTypeEnum {
  notDefined = 0,
  federal = 1,
  province = 2,
}

export enum FicaStatusTypeEnum {
  notDefined = 0,
  exempt = 1,
  subject = 2,
  medicare = 3,
}

export enum EmployeeOnboardingStepTypeEnum {
  notDefined = 0,
  basicInformation = 1,
  jobDetails = 2,
  taxInformation = 3,
  incomeDeducationsAndBenefits = 4,
  priorPayrolls = 5,
  finalReview = 6,
  paymentInformation = 7,
}

export enum TimeZoneTypeEnum {
  notDefined = 0,
  easternStandard = 1,
  indiaStandard = 2,
  atlanticTime = 3,
  niueTime = 4,
  samoaStandard = 5,
}

export enum DontShowMeTypeEnum {
  notDefined = 0,
  disableLocation = 1,
  disableWcbRate = 2,
  disableField = 4,
  changeCompanyOverrideField = 8,
  disablePayGroup = 16,
  disableJob = 32,
  disableDepartment = 64,
  accountStatusIdle = 128,
  employeeProfileCompletion = 256,
  disablePerson = 512,
  hourlyRateExceedsUpperLimit = 1024,
  hideDeductionsAlert = 2048,
  hideRoePayrollInfoAlert = 4096,
  hideRoeStatHolidayAlert = 8192,
  skipProductTour = 16384,
  modalFtuOnboarding = 32768,
  adjustVacationInRegularPayProTip = 65536,
  hideAccountSignatureWarning = 131072,
  hidePartnerInvitationForFtu = 262144,
  hideBox45YearEndBanner = 524288,
  hideBox15YearEndBanner = 1048576,
  hideTrialEndingBanner = 2097152,
  hideEmploeeBankingChanged = 4194304,
  hideAdminAutoAssignBanner = 8388608,
  hideUpgradeClientBanner = 8388608,
  hideMigrationNextStepsBanner = 33554432,
  hideMigratedPartnerAddClientBanner = 268435456,
  hideClientUpgradeReminderBanner = 536870912,
  HidePartnerSignPadBanner = 67108864,
  HidePartnerUpgradeBanner = 134217728,
  HideAccountantConsentModal = 1073741824,
  HideNonStandardPayGroupBanner = 8388608,
}

export enum JobDefinitionStatusTypeEnum {
  notDefined = 0,
  active = 1,
  disabled = 2,
}

export enum DepartmentStatusTypeEnum {
  notDefined = 0,
  active = 1,
  disabled = 2,
}

export enum StartDateTypeEnum {
  notDefined = 0,
  hired = 1,
  returnToWork = 2,
}

export enum EndDateTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  onLeave = 2,
  terminated = 3,
}

export enum OnboardingStepStatusTypeEnum {
  notDefined = 0,
  skipped = 1,
  completed = 2,
  staffOnboardPending = 3,
  incomplete = 4,
}

export enum DepartmentTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  finance = 2,
  risk = 3,
  customerSuccess = 4,
  informationTechnology = 5,
}

export enum StaffOnboardFieldGroupTypeEnum {
  notDefined = 0,
  personal = 1,
  social = 2,
  tax = 3,
  bank = 4,
}

export enum VendorTypeEnum {
  notDefined = 0,
  individual = 1,
  business = 2,
}

export enum PersonOnboardStepStatusTypeEnum {
  notDefined = 0,
  pending = 1,
  partiallyCompleted = 2,
  completed = 3,
  selfOnboardPending = 4,
}

export enum ChildOnboardingStepTypeEnum {
  personal = 0,
  bank = 1,
}

export enum JobStatusTypeEnum {
  notDefined = 0,
  active = 1,
  disabled = 2,
  deleted = 3,
}

export enum DefaultProfileImageEnum {
  default_profile_image_1 = 40,
  default_profile_image_2 = 41,
  default_profile_image_3 = 42,
  default_profile_image_4 = 43,
  default_profile_image_5 = 44,
  default_profile_image_6 = 45,
}

export enum PaymentMethodTypeEnum {
  notDefined = 0,
  directDeposit = 1,
  cheque = 2,
}

export enum CultureTypeEnum {
  notDefined = 0,
  englishUs = 1,
  englishCa = 2,
  frenchCa = 3,
}

export enum ConfigurationTypeEnum {
  notDefined = 0,
  menu = 1,
}

export enum ApplicationTypeEnum {
  wagepoint = 0,
  employeePortal = 1,
  alfred = 2,
  accountingDashboard = 3,
}

export interface CompanyInterface {
  id: number;
  companyTypeFlags: number;
  primaryContactId?: number;
  companyStatusTypeId: number;
  accountExecutivePersonId?: number;
  name: string;
  dba: string;
  description: string;
  email: string;
  employeeLocation: string;
  revision: number;
  parentId?: number;
  companyCode: string;
  locationJson: string;
  payrollPrice?: number;
  employeePrice?: number;
  billParent?: boolean;
  marketingInfomation: string;
}

export interface CompanyDecendentInterface {
  decendendIdList: string;
}

export interface FormBoxValueInterface {
  stringValue: string;
  decimalValue?: number;
  dateValue?: string;
  formPk: string;
  formRk: string;
  formBoxId: number;
  index: number;
}

export interface TaxAgreementInterface {
  formId: number;
  formStatusTypeId: number;
  documentId?: number;
  isDigitallySigned: boolean;
  signatureDate?: string;
  legacyName: string;
  legacyPath: string;
  legacyTags: string;
  legacyCorrelationKey?: string;
}

export interface TaxFormInterface {
  formId: number;
  formStatusTypeId: number;
  employeeId: number;
  employeeTypeId: number;
  employmentProvinceId?: number;
  xmlBatchDocumentId?: number;
  taxYear: number;
  formName: string;
  yearEndPackageId: number;
  yearEndTaxFormId: number;
  revision: number;
  lastFiledYearEndTaxFormId?: number;
  workflowStatusType: number;
}

export interface YearEndCheckInterface {
  yearEndViolationTypeId: number;
  personId: number;
  contribution: number;
  deficiency: number;
  yearEndCheckStatusTypeId: number;
}

export interface TaxFormXmlInterface {
  yearEndTaxFormId: number;
  xmlContent: string;
  formId: number;
}

export interface TaxFormsSummaryBoxValueInterface {
  formPk: string;
  formRk: string;
  formBoxId?: number;
  otherFormBoxName: string;
  stringValue: string;
}

export interface TaxSummaryFormInterface {
  formId: number;
  formStatusTypeId: number;
  documentId?: number;
  formName: string;
  yearEndPackageId: number;
  workflowStatusType: number;
  xmlContent: string;
  isOriginal: boolean;
  updatedDate?: string;
  updatedBy: string;
}

export interface TaxFormJsonInterface {
  yearEndTaxFormId: number;
  formId: number;
  jsonContent: string;
}

export interface TaxFormBoxInterface {
  formBoxName: string;
  value: string;
}

export interface CompanyBlacklistDataInterface {
  companyId: number;
}

export interface TaxFormPackageXmlInterface {
  yearEndPackageId: number;
  xmlContent: string;
  formId: number;
}

export interface ClientInvitationInterface {
  companyName: string;
  email: string;
  firstName: string;
  lastName: string;
  country: string;
  subscriptionPlanId: number;
  isNewCompanyInvitation: boolean;
}

export interface MarketingInstitutionInfoInterface {
  institutionType: MarketingInstitutionTypeEnum;
  name: string;
  referrerEmail: string;
}

export interface CalendarInterface {
  id: number;
  name: string;
  isActive: boolean;
  calendarOwnerId: number;
  calendarOwnerType: CalendarOwnerTypeEnum;
  companyId?: number;
  calendarEventList: Array<CalendarEventInterface>;
}

export interface CalendarEventInterface {
  id: number;
  isActive: boolean;
  calendarEventType: CalendarEventTypeEnum;
  eventJson: string;
  calendarEventStateType: CalendarEventStateTypeEnum;
  nextWakeupTime: string;
  anchorDate: string;
  startDate?: string;
  endDate?: string;
}

export interface NotificationScheduleInterface {
  anchorDeltaSeconds: string;
  isFinal: string;
  notificationTemplateId: string;
  finalRepeatSeconds?: number;
}

export interface StatPayCalculationHolidayInterface {
  isFederalHoliday: boolean;
  hoursPerDay: number;
}

export interface EchoSignEventInterface {
  adobeEventTypeId?: number;
  isProcessed: boolean;
  eventDate: string;
}

export interface EchoSignInterface {
  agreementId: string;
  agreementUrl: string;
  agreementEmailViewed: boolean;
  email: string;
  signed: boolean;
  documentId?: number;
  documentTypeId: number;
  workflowJson: string;
  processorProxyName: string;
}

export interface TruliooVerificationInterface {
  recordId: string;
  transactionId: string;
  verificationTypeId: number;
  personId?: number;
  companyId?: number;
  isVerified: boolean;
  isCurrent: boolean;
  bankAccountId: number;
}

export interface BankFileNextNumberInterface {
  nextNumber: number;
  startNumber: number;
}

export interface CountrySpecificInterface {
  country: string;
  propertyName: string;
  propertyValue: string;
}

export interface EmployeeInterface {
  id: number;
  nationalId: string;
  activeBankAccountId?: number;
  payGroupId?: number;
  withholdIncomeTax?: boolean;
  employerEmployeeId?: string;
  taxInclusions: string;
  companyLocationId?: number;
  relevantStateId?: number;
  relevantStateAbbreviation: string;
  governmentNumber: string;
  isInvited: boolean;
  employeeStateTypeId: number;
  payrollEmployeeStateTypeId: number;
  taxSettingListJson: string;
  companyId: number;
  personTypeId: number;
  firstName: string;
  middleName?: string;
  lastName: string;
  birthDate?: string;
  maritalStatus: number;
  gender: string;
  userId?: number;
  revision: number;
  startDate?: string;
  endDate?: string;
  isMidCycleHirre: string;
  midCycleHireDays?: number;
  midCycleTerminateDays?: number;
  isMidCycleTerminate: string;
  startDateTypeId?: number;
  endDateTypeId?: number;
  emergencyPersonJson: string;
  phoneNumber: string;
  isPhoneVerified: boolean;
  emailListJson: string;
  addressListJson: string;
  updatedBy: string;
  taxSchemeTypeId?: number;
  returnDate?: string;
  proratedHours?: number;
  paymentMethodId: number;
}

export interface EmergencyPersonInterface {
  name: string;
  propertyDc1: string;
  propertyDc2: string;
  propertyDc3: string;
  propertyDc4: string;
  propertyDc5: string;
}

export interface WcbRateInterface {
  id: number;
  stateId: number;
  companyId: number;
  accountNumber: string;
  rate: number;
  effectiveDate?: string;
  wcbRateStatusTypeId: number;
  maxEarnings: number;
  revision: number;
  jobRevision: number;
  updatedBy: string;
  usedInPayroll: boolean;
  nextAllowedEffectiveDate?: string;
  isLocked: boolean;
  premiumRate: number;
}

export interface JobInterface {
  id: number;
  jobPayTypeId: number;
  hoursTypeId: number;
  payPeriodHours?: number;
  hourlyPayRate?: number;
  annualSalary?: number;
  companyLocationId?: number;
  isPrimaryJob: boolean;
  employmentTypeId: number;
  name: string;
  revision: number;
  jobDefinitionId?: number;
  departmentId?: number;
  wcbRateId?: number;
  employeeId: number;
  jobOverideFieldJson: string;
  vacationCalculationTypeId: number;
  vacationStateId?: number;
  vacationPercent?: number;
  wcbRateRevision?: number;
  updatedBy: string;
  departmentName: string;
  jobDefinitionName: string;
  effectiveFromDate?: string;
  effectiveToDate?: string;
  companyId: number;
  isMidCyclePayChange: boolean;
  midCyclePayDays?: number;
  workFromHomeEnabled?: boolean;
  residenceStateId?: number;
  jobStatusTypeId: number;
}

export interface EmployeeTaxSettingsInterface {
  id: number;
  correlationKey?: string;
  maritalStatusTypeId: number;
  companyFieldId?: number;
  isExempt: boolean;
  isActive: boolean;
  isResident: boolean;
  exemptions: number;
  taxUpdateMiscellaneousCode?: string;
  taxUpdateAuxiliaryCode?: boolean;
  stateId?: number;
  isEveryState: boolean;
  filingStatusTypeId?: number;
  overrideTaxComputation: boolean;
  overrideValueTypeId: number;
  overrideValue: number;
  revision: number;
  isDeleted: boolean;
  employeeRevision: number;
  updatedBy: string;
  effectiveFromDate: string;
  effectiveToDate: string;
  isReducedRate?: boolean;
}

export interface ContactInterface {
  addressList: Array<AddressInterface>;
  emailList: Array<EmailInterface>;
  phoneList: Array<PhoneInterface>;
}

export interface EmailInterface {
  id: number;
  emailAddress: string;
  emailType: EmailTypeEnum;
}

export interface AddressInterface {
  id: number;
  addressType: AddressTypeEnum;
  address1: string;
  address2: string;
  postal: string;
  city: string;
  country: string;
  stateId?: number;
  countryType: CountryTypeEnum;
  employeeRelevantStateId?: number;
  effectiveFromDate?: string;
  effectiveToDate?: string;
}

export interface PhoneInterface {
  id: number;
  phoneNumber: string;
  phoneType: PhoneTypeEnum;
}

export interface QuickEmployeePayDataInterface {
  ytdNetPay: number;
  ytdGrossPay: number;
  ytdDeductions: number;
  ytdTaxes: number;
  lastNetPay: number;
  lastGrossPay: number;
  lastDeductions: number;
  lastTaxes: number;
}

export interface CompensationInterface {
  id: number;
  jobId: number;
  hoursTypeId: number;
  jobPayTypeId: number;
  payPeriodHours: number;
  hourlyPayRate: number;
  annualSalary: number;
  revision: number;
  updatedBy: string;
  effectiveFromDate?: string;
  effectiveToDate?: string;
  updatedDate?: string;
  companyId: number;
  jobAnnualSalary: number;
  jobHourlyPayRate: number;
  jobPayPeriodHours: number;
  hourPerDay: number;
  proratedHours: number;
}

export interface RelevantStateInterface {
  id: number;
  name: string;
  shortName: string;
  countryType: number;
  usedByApprovedPayroll: boolean;
  effectiveFromDate: string;
  effectiveToDate: string;
  employeeRelevantStateId: number;
}

export interface SelfOnboardGroupStatusInterface {
  fieldGroupId: number;
  isCompleted: boolean;
}

export interface UserOptInInterface {
  userId: number;
  applicationType: ApplicationTypeEnum;
  optInKeyAssignmentDate?: string;
}

export interface PersonOnboardStepStatusInterface {
  personOnboardStepStatusType: PersonOnboardStepStatusTypeEnum;
  employeeOnboardingStepType: EmployeeOnboardingStepTypeEnum;
  childOnboardStepStatusList: Array<ChildOnboardStepStatusInterface>;
}

export interface ChildOnboardStepStatusInterface {
  childOnboardStepStatusType: PersonOnboardStepStatusTypeEnum;
  childOnboardingStepType: ChildOnboardingStepTypeEnum;
}

export interface CompensationHistoryInterface {
  id: number;
  jobId: number;
  hoursTypeId: number;
  jobPayTypeId: number;
  payPeriodHours: number;
  hourlyPayRate: number;
  annualSalary: number;
  revision: number;
  updatedBy: string;
  departmentName: string;
  jobDefinitionName: string;
  effectiveFromDate?: string;
  effectiveToDate?: string;
  updatedDate?: string;
  companyId: number;
  jobAnnualSalary: number;
  jobHourlyPayRate: number;
  jobPayPeriodHours: number;
  payPeriodId: number;
  updatedByUserId: number;
  hourPerDay: number;
  proratedHours: number;
}

export interface WcbRateSettingInterface {
  id: number;
  toolTip: string;
  wcbValidationType: number;
  maxEarnings: number;
  exemptTaxes?: boolean;
  stateId: number;
}

export interface ProvinceOfEmploymentInterface {
  employeeId: number;
  stateId: number;
  basicInformation: string;
  job: string;
  tax: string;
  homeAddress: string;
}

export interface KeyRevisionInterface {
  primaryKey: number;
  foreignKey: number;
  revision: number;
}

export interface UserAuthenticationInterface {
  userId: number;
  twoFactorType: number;
  secretKey: string;
  secretKeyAssignmentDate?: string;
  rememberMe: boolean;
  visitorId: string;
  twoFactorTypeAssignmentDate: string;
  visitorIdAssignmentDate: string;
}

export interface FingerprintInterface {
  visitorId: string;
  ipAddress: string;
  country: string;
  browserName: string;
  operatingSystem: string;
}

export interface UserFingerprintInterface {
  emailAddress: string;
  userId?: number;
  companyId?: number;
  attemptCount: number;
  accessDate?: string;
  fingerprintVisitorId: string;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}
